export function cn(...inputs: (string | undefined | null | false)[]) {
  const classes = inputs.filter(Boolean) as string[]
  return classes.join(' ')
}
